module.exports = __webpack_public_path__ + "img/half-8.a16108b.png";